import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import {
  createFileRoute,
  useNavigate,
  useParams,
} from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBox } from '@/common/AlertBox';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import { WBSButton } from '@/common/WBSButton';
import { MassMessagingTable } from '@/tables/MassMessagingTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const MASS_MESSAGING_SENT_FLAG = 'massMessagingSent';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/mass-messaging/',
)({
  component: MassMessagingRoute,
});

function MassMessagingRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const { groupName } = useParams({
    from: '/_app/_dashboard/groups/$groupName/mass-messaging/',
  });

  useEffect(() => {
    if (sessionStorage.getItem(MASS_MESSAGING_SENT_FLAG) !== '1') return;
    sessionStorage.removeItem(MASS_MESSAGING_SENT_FLAG);
    setSent(true);
  }, []);

  return (
    <>
      {(sent || deleted) && (
        <div style={{ marginTop: '16px' }}>
          <AlertBox variant="success">
            {sent
              ? t('notifications.message-sent-successfully')
              : t('actions.message-has-been-deleted')}
          </AlertBox>
        </div>
      )}
      <GroupHeaderWrapper>
        <TitleWithQuestion title={t('wbs.mass-messaging')} />
        <WBSButton
          wide
          icon={faCirclePlus}
          onClick={() =>
            navigate({
              to: '/groups/$groupName/mass-messaging/new/',
              params: { groupName },
            })
          }
        >
          {t('wbs.compose')}
        </WBSButton>
      </GroupHeaderWrapper>
      <MassMessagingTable
        groupName={groupName}
        onDelete={() => setDeleted(true)}
      />
    </>
  );
}
